export const unexpectedErrorGraph = 'Unexpected error occurred while loading this graph.';
